// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import appInfo from '../../../../configs/app-info';

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid, { GridProps } from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import CircularProgress from '@mui/material/CircularProgress'
import FormLabel from '@mui/material/FormLabel'
import {
    CardActions,
    Divider,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    Tooltip,
    Fab,
    FormControlLabel,
    Checkbox,
    OutlinedInput,
    Rating,
    Autocomplete
} from '@mui/material'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'

import { useNavigate } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import MsiDatagridDynamic from '../../../../components/custom/MsiDatagridDynamic';
import apiUrl from '../../../../configs/constant';

const listTingkat = [
    { id: 1, nama: 1 },
    { id: 2, nama: 2 },
    { id: 3, nama: 3 },
    { id: 4, nama: 4 },
    { id: 5, nama: 5 },
    { id: 6, nama: 6 },
    { id: 7, nama: 7 },
    { id: 8, nama: 8 },
    { id: 9, nama: 9 }
]

export default function Add() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    // ** State
    const [valDivisi, setValDivisi] = useState<any>(null)
    const [listDivisi, setListDivisi] = useState<any[]>([])

    const [valProfitCenter, setValProfitCenter] = useState<any>(null)
    const [listProfitCenter, setListProfitCenter] = useState<any[]>([])

    const [valHrstaff, setValHrstaff] = useState<any>(null)
    const [listHrstaff, setListHrstaff] = useState<any[]>([])

    const [valPayrollRumus, setValPayrollRumus] = useState<any>(null)
    const [listPayrollRumus, setListPayrollRumus] = useState<any[]>([])

    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [valHrJabatan, setValHrJabatan] = useState<any>(null)
    const [listHrJabatan, setListHrJabatan] = useState<any[]>([])

    useEffect(() => {
        getDoctag()
        getDivisi()
        getJabatan()
    }, [])

    const getDoctag = () => {
        const url = apiUrl.apiUrl + '/system/doctag/list-combo'
        axios
            .get(url, {
                params: {
                    syscabang_id: cabang,
                    sysmenu_id: 44
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListDoctag(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getDivisi = () => {
        const url = apiUrl.apiUrl + '/hr/divisi/list-combo/' + cabang
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListDivisi(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getJabatan = () => {
        const url = apiUrl.apiUrl + '/hr/jabatan/list-combo/' + cabang
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListHrJabatan(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const navigate = useNavigate();

    interface FormInputs {
        syscabang_id: any,
        sysdoctag_id: any,
        hrjabatan_id: any,
        hrdivisi_id: any,
        hrstaff_id: any,
        hrjenisperiode_id: any,
        hrpayroll_rumus_id: any,
        accprofitcenter_id: any,
        hrstaffregu_id: any,
        hrshift_id: any,
        nik: any,
        nama: any,
        nama2: any,
        tgl_lahir: any,
        alamat: any,
        jk: any,
        telp: any,
        wa: any,
        no_ktp: any,
        is_tetap: any,
        is_outsource: any,
        email: any,
        gaji: any,
        bank: any,
        bank_number: any
    }

    const defaultValues = {
        syscabang_id: cabang
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })


    const handleChangeAutocompleteDivisi = (event: SyntheticEvent, newValue: any | null) => {
        setValue('hrdivisi_id', newValue?.id)
        setValDivisi(newValue)
    }

    const handleChangeAutocompleteProfitCenter = (event: SyntheticEvent, newValue: any | null) => {
        setValue('accprofitcenter_id', newValue?.id)
        setValProfitCenter(newValue)
    }

    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue?.id)
        setValDoctag(newValue)
    }

    const handleChangeAutocompletePayrollRumus = (event: SyntheticEvent, newValue: any | null) => {
        setValue('hrpayroll_rumus_id', newValue?.id)
        setValPayrollRumus(newValue)
    }

    const handleChangeAutocompleteHrJabatan = (event: SyntheticEvent, newValue: any | null) => {
        setValue('hrjabatan_id', newValue?.id)
        setValHrJabatan(newValue)
    }

    const handleChangeAutocompleteHrStaff = (event: SyntheticEvent, newValue: any | null) => {
        setValue('hrstaff_id', newValue?.id)
        setValHrstaff(newValue)
    }

    const onSubmit = (data: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/hr/staff/add'
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    navigate('/hr/staff')
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Buat Master Staff
                    </Typography>
                    <Divider sx={{ m: 0 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Document Tag
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='sysdoctag_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valDoctag}
                                                options={listDoctag}
                                                id='sysdoctag_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteDoctag}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Document Tag'
                                                        error={Boolean(errors.sysdoctag_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.sysdoctag_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Divisi
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='hrdivisi_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valDivisi}
                                                options={listDivisi}
                                                id='hrdivisi_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteDivisi}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Divisi'
                                                        error={Boolean(errors.hrdivisi_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.hrdivisi_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Jabatan
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='hrjabatan_id'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valHrJabatan}
                                                options={listHrJabatan}
                                                id='hrjabatan_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteHrJabatan}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Jabatan'
                                                        error={Boolean(errors.hrjabatan_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.hrjabatan_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Perhitungan Payroll
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='hrpayroll_rumus_id'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valPayrollRumus}
                                                options={listPayrollRumus}
                                                id='hrpayroll_rumus_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompletePayrollRumus}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Perhitungan Payroll'
                                                        error={Boolean(errors.hrpayroll_rumus_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.hrpayroll_rumus_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Atasan
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='hrstaff_id'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valHrstaff}
                                                options={listHrstaff}
                                                id='hrstaff_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteHrStaff}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Atasan'
                                                        error={Boolean(errors.hrstaff_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.hrstaff_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Nomor Induk Karyawan
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nik'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Nomor Induk Karyawan'
                                                error={Boolean(errors.nik)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.nik && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Nama Lengkap
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nama'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Nama Lengkap'
                                                error={Boolean(errors.nama)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.nama && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Nama Panggilan
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nama2'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Nama Panggilan'
                                                error={Boolean(errors.nama)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.nama2 && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    NIK (No. KTP)
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='no_ktp'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='NIK (No. KTP)'
                                                error={Boolean(errors.no_ktp)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.no_ktp && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Tanggal Lahir
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='tgl_lahir'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Tanggal Lahir'
                                                type='date'
                                                error={Boolean(errors.tgl_lahir)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.tgl_lahir && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    No. HP
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='wa'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='No. HP'
                                                type='number'
                                                error={Boolean(errors.wa)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.wa && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5 }}>
                                    Jenis Kelamin
                                </Typography>
                                <FormControl sx={{}}>
                                    <Controller
                                        name='jk'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => {
                                            return (
                                                <RadioGroup row value={value} onChange={onChange}>
                                                    <FormControlLabel value='L' control={<Radio />} label='Laki-laki' />
                                                    <FormControlLabel value='P' control={<Radio />} label='Perempuan' />
                                                    {/* <FormControlLabel value='L/P' control={<Radio />} label='Laki-laki & Perempuan' /> */}
                                                </RadioGroup>
                                            )
                                        }}
                                    />
                                    {errors.jk && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                                    Gaji
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='gaji'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => {
                                            return (
                                                <TextField
                                                    fullWidth
                                                    label='Gaji'
                                                    name='gaji'
                                                    value={
                                                        value !== undefined && value !== null && value !== ''
                                                            ? (() => {
                                                                // Format value for display: replace dot with comma, add thousand separator
                                                                const str = String(value).replace('.', ',')
                                                                const [integer, decimal] = str.split(',')
                                                                let formatted = integer ? Number(integer).toLocaleString('id-ID') : ''
                                                                if (decimal !== undefined) {
                                                                    formatted += ',' + decimal
                                                                }
                                                                return formatted
                                                            })()
                                                            : ''
                                                    }
                                                    onChange={e => {
                                                        let input = e.target.value

                                                        // Remove all except digits and comma
                                                        input = input.replace(/[^0-9,]/g, '')

                                                        // Split integer and decimal part
                                                        const [intPart, decimalPart] = input.split(',')

                                                        // Format integer part with thousand separator
                                                        let formatted = ''
                                                        if (intPart) {
                                                            const parsed = parseInt(intPart, 10)
                                                            formatted = isNaN(parsed) ? '' : parsed.toLocaleString('id-ID')
                                                        }
                                                        if (decimalPart !== undefined) {
                                                            formatted += ',' + decimalPart
                                                        }

                                                        // Raw value for backend: replace comma with dot
                                                        const rawValue = decimalPart !== undefined ? `${intPart}.${decimalPart}` : intPart

                                                        setValue('gaji', rawValue)
                                                    }}
                                                    InputLabelProps={{ shrink: true }}
                                                    inputProps={{ inputMode: 'decimal' }}
                                                />
                                            )
                                        }}
                                    />
                                    {errors.gaji && (
                                        <FormHelperText sx={{ mt: 0, color: 'error.main' }}>
                                            Form ini tidak boleh kosong.
                                        </FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                                    Bank
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='bank'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Bank'
                                                error={Boolean(errors.bank)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.bank && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                                    Nomor Rekening
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='bank_number'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Nomor Rekening'
                                                type='number'
                                                error={Boolean(errors.bank_number)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.bank_number && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1.5 }}>
                                    Alamat
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='alamat'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Alamat'
                                                multiline
                                                rows={2}
                                                error={Boolean(errors.alamat)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.alamat && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>
        </Grid>
    )
}
